export const NAMESPACE = 'KanBo/MyBoard/settings/'
export const SET = NAMESPACE + 'SET'

const initialState = {}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case SET:
      return {
        ...state,
        ...action.payload
      }
    default: return state
  }
}

export function set (payload) {
  return {
    type: SET,
    payload
  }
}
